export default class MailText {
  // method to get the correct translation by element key and destination
  // returns null, if destination or key not found
  static getTextElement(destinationKey, elementKey, language) {
    const elementsByDestination = this.texts()[destinationKey]
    if (!elementsByDestination) return null
    let elementsByKey = elementsByDestination[elementKey]
    if (!elementsByKey) {
      // try with neutral entry and closing lines to save texts
      if (elementKey.startsWith('entryLine')) {
        elementsByKey = elementsByDestination['entryLineN']
      }
      if (elementKey.startsWith('closingLine')) {
        elementsByKey = elementsByDestination['closingLineN']
      }
      if (!elementsByKey) return null
    }
    const elementByLanguage = elementsByKey[language]
    if (!elementByLanguage) {
      // if language doesn't exist, just return the first translation
      return elementsByKey[Object.keys(elementsByKey)[0]]
    }
    return elementByLanguage
  }

  // configuration
  static texts() {
    return {
      niesen: {
        salutationN: {
          de: 'Sehr geehrte/r',
        },
        salutationM: {
          de: 'Sehr geehrter Herr',
        },
        salutationF: {
          de: 'Sehr geehrte Frau',
        },
        entryLineReserved: {
          de:
            "<p>Besten Dank für Ihre Anfrage. Gerne haben wir für Sie folgende Leistungen im Berghaus Niesen Kulm auf 2'334 m ü. M. reserviert:</p>",
        },
        entryLineWaitingList: {
          de:
            "<p>Besten Dank für Ihre Anfrage. Gerne haben wir Sie für folgende Leistungen im Berghaus Niesen Kulm auf 2'334 m ü. M. auf die Warteliste gesetzt:</p>",
        },
        entryLineConfirmed: {
          de:
            "<p>Besten Dank für Ihre Buchung im Berghaus Niesen Kulm auf 2'334 m ü. M. Gerne haben wir für Sie folgende Leistungen gebucht:</p>",
        },
        closingLineReserved: {
          de:
            '<p>Bitte bestätigen Sie uns diese Reservation bis spätestens am</p> <h1><b>(DEADLINE ERGÄNZEN)</b></h1>',
        },
        closingLineWaitingList: {
          de:
            '<p>Sie werden wieder von uns hören, sobald wir für Sie für die gewünschten Leistungen eine Buchung vornehmen können.</p>',
        },
        closingLineConfirmed: {
          de:
            '<p>Bitte melden Sie sich bei Ihrer Ankunft bei uns an der Kasse, um die Tickets abzuholen und zu bezahlen.</p>',
        },
        greetings: {
          de:
            '<p>Wir freuen uns auf Ihren Besuch.</p>' +
            '<p>Freundliche Grüsse</p>' +
            '<p>Ihr Team der Niesenbahn AG</p>',
        },
        on: {
          de: 'am',
        },
      },
      nendaz: {
        salutationN: {
          fr: 'Chère Madame / Cher Monsieur',
          en: 'Dear',
          de: 'Sehr geehrte/r',
        },
        salutationM: {
          fr: 'Cher Monsieur',
          en: 'Dear Mr.',
          de: 'Sehr geehrter Herr',
        },
        salutationF: {
          fr: 'Chère Madame',
          en: 'Dear Mrs.',
          de: 'Sehr geehrte Frau',
        },
        entryLineN: {
          fr:
            '<p>Nous vous remercions pour votre réservation. Votre commande est la suivante :</p>',
          en:
            '<p>Thank you for your booking. Your order is now confirmed, as follows :</p>',
          de:
            '<p>Vielen Dank für Ihre Buchung. Gerne bestätigen wir Ihnen Ihre Buchung wie folgt:</p>',
        },
        on: {
          de: 'am',
          en: 'on',
          fr: 'le',
        },
        closingLineN: {
          fr:
            '<p>Muni de votre confirmation, vous pouvez retirer vos billets directement sur place avant d’utiliser nos installations auprès de nos guichets. Si votre commande n’est pas encore réglée, vous effectuerez le paiement sur place. Consultez la page dédiée de site internet pour connaître les détails de votre  excursion (lieu de rendez-vous, horaires, programme éventuelles restrictions).</p>' +
            '<p>Nous nous réjouissons de votre visite !</p>' +
            '<p>En cas de question, vous pouvez contacter le +41 (0) 27 289 52 00 ou info@nvrm.ch.</p>',
          en:
            '<p>With your confirmation, you can pick up your tickets directly on site before using our transport facilities. If your order was not already paid, you can do it at our cash desks on the day of the tour. Please have a look in advance at the dedicated page of our website to have all the details regarding your trip (meeting point, timing, programme, possible restrictions etc.)</p>' +
            '<p>We look forward to welcoming you soon!</p>' +
            '<p>If you have more question, do not hesitate to contact us by phone +41 (0) 27 289 52 00 or by mail info@nvrm.ch.</p>',
          de:
            '<p>Mit dieser Bestätigung können Sie Ihre Tickets direkt vor Ort abholen, bevor Sie unsere Transportanlagen nutzen. Falls Ihre Bestellung noch nicht bezahlt wurde, können Sie dies am Tag des Erlebnisses direkt an unseren Kassen nachholen. Bitte werfen Sie vorab einen Blick auf die entsprechende Produktseite unserer Website, um alle Details zu Ihrer Reise zu erfahren (Treffpunkt, Zeitplan, Programm, mögliche Einschränkungen usw.)</p>' +
            '<p>Wir freuen uns darauf, Sie bald begrüßen zu dürfen!</p>' +
            '<p>Wenn Sie weitere Fragen haben, zögern Sie nicht, uns unter der Telefonnummer +41 (0) 27 289 52 00 oder per Mail info@nvrm.ch zu kontaktieren.</p>',
        },
        greetings: {
          fr:
            '<p>Meilleures salutations</p>' +
            '<p>Votre Team Nendaz-Veysonnaz</p>' +
            '<p><a href="https://nendaz.ch/excursion" target="_blank">nendaz.ch/excursion</a> et <a href="https://nendaz.pricenow.ch" target="_blank">nendaz.pricenow.ch</a></p>',
          en:
            '<p>Kind regards</p>' +
            '<p>Your Nendaz-Veysonnaz Team</p>' +
            '<p><a href="https://nendaz.ch/excursion" target="_blank">nendaz.ch/excursion</a> and <a href="https://nendaz.pricenow.ch" target="_blank">nendaz.pricenow.ch</a></p>',
          de:
            '<p>Mit freundlichen Grüssen</p>' +
            '<p>Ihr Nendaz-Veysonnaz Team</p>' +
            '<p><a href="https://nendaz.ch/excursion" target="_blank">nendaz.ch/excursion</a> und <a href="https://nendaz.pricenow.ch" target="_blank">nendaz.pricenow.ch</a></p>',
        },
      },
    }
  }
}
